import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const dictionary = {
  'card_first_progress_indicator.step_prefix.label': {
    'en-GB': ({
      activeStep,
      totalSteps,
    }: {
      activeStep: number
      totalSteps: number
    }) => `Step ${activeStep} of ${totalSteps}`,
    'nl-NL': ({
      activeStep,
      totalSteps,
    }: {
      activeStep: number
      totalSteps: number
    }) => `Stap ${activeStep} van ${totalSteps}`,
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
